import { Button, ButtonProps } from "@components/ui/Button"
import { Tooltip } from "@components/ui/Tooltip"
import { trackEvent } from "@features/tracking/tracking"
import { useRef, useState } from "react"

type Props = Partial<ButtonProps>

export function ShareButton(props: Props) {
  const ref = useRef<HTMLButtonElement>(null)
  const [copied, setCopied] = useState(false)

  async function copyToClipboard() {
    await navigator.clipboard.writeText(window.location.href)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  async function nativeShare() {
    if (!navigator.share) throw new Error("Native share not supported")
    navigator
      .share({
        url: window.location.href,
      })
      .catch((err) => {})
  }

  return (
    <Tooltip forceOpen={copied} label={<>Link copied!</>}>
      <Button
        leftIcon="link"
        variant="default"
        children="Share"
        ref={ref}
        onClick={async (e) => {
          trackEvent("Share Button Clicked", {}, e.currentTarget)
          let methods = [nativeShare, copyToClipboard]
          if (window.innerWidth > 1280) {
            methods = [copyToClipboard, nativeShare]
          }
          for (let method of methods) {
            try {
              await method()
              return
            } catch (err) {
              if (env.dev) {
                console.log({ err })
                console.error(err)
              }
              continue
            }
          }
        }}
        {...props}
      />
    </Tooltip>
  )
}
